<template>
  <svg
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
    :class="svgClass"
    :style="svgStyle"
  >
    <path
      d="M18.57,42c5.11-6.32,2.63-12.48-1.94-17.75,0,8.12-12,10.41-5.33,17.75C5.21,40.29,1.08,35.7.39,30.09s3-10.75,6.33-15.8C3.84,25.44,11,25.75,12.55,22S10,16.14,10,11.42s2.46-8.12,5.49-11c0,15.66,14,17.29,14.42,27.27C30.18,34.38,25.82,40.13,18.57,42Z"
      :style="{'fill': fill}"
    />
  </svg>
</template>

<script>
export default {
  components: {},
  props: {
    viewBox: { type: String, default: '0 0 30.19 42.45' },
    fill: { type: String, default: '#FFFFFF' },
    svgClass: { type: String, default: 'svg-icon' },
    svgStyle: { type: Object },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
